module.exports = __webpack_public_path__ + "static/media/gyoritrening.5e86888c.png";